import React from "react";
import { Card } from "../../card";
import { StudentResultSpreadsheet } from "./StudentResultSpreadsheet";
import { setPaginatedStudentResultList } from "../../../Redux/Slices/studentResuilt.slice";
import { useGetStudentListForResult } from "../../../hooks/resultsHooks/studentResult.hooks";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../Redux/store";
import { Loader } from "../../loader/Loader";

interface Props {
  resultId: number;
}
export const StudentResult = ({ resultId }: Props) => {
  const dispatch = useDispatch();

  const { pageNo } = useSelector((state: RootState) => ({
    pageNo: state.studentResult.pageNo,
  }));

  const { isLoading } = useGetStudentListForResult({
    resultId,
    page: pageNo,
    onSuccess: (data) => {
      dispatch(setPaginatedStudentResultList(data));
    },
  });

  if (isLoading) return <Loader isLoading={isLoading} />;

  return (
    <Card wrapperStyle={{ height: "100%" }} cardTitle="Student results">
      <StudentResultSpreadsheet resultId={resultId} />
    </Card>
  );
};
